import { render, staticRenderFns } from "./EditDriver.vue?vue&type=template&id=48d72869&scoped=true"
import script from "./EditDriver.vue?vue&type=script&lang=js"
export * from "./EditDriver.vue?vue&type=script&lang=js"
import style0 from "./EditDriver.vue?vue&type=style&index=0&id=48d72869&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d72869",
  null
  
)

export default component.exports